import React from "react";
export const List = React.forwardRef(({ as: Element = "ul", children, ...rest }, ref) => {
    return (React.createElement(Element, { ref: ref, role: "list", ...rest }, children));
});
//# sourceMappingURL=List.js.map